import ModuleWrapper from '@/components/page/ModuleWrapper';

const ProfileDetails = () => import(/* webpackChunkName: "profile-details" */ '@/views/Profile/ProfileDetails');

const meta = (data = {}) => ({
    auth: true,
    title: 'Profile',
    ...data,
});

export default [{
    path: 'profile',
    component: ModuleWrapper,
    meta: meta({
        title: 'Profile',
    }),
    children: [
        {
            path: '',
            name: 'ProfileDetails',
            component: ProfileDetails,
            props: true,
            meta: meta(),
        },
    ],
}];
